import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { NEWS } from "@/lib/site-data";

export default function Article() {
    const { slug } = useParams();
    const article = NEWS.find((n) => n.slug === slug);

    if (!article) return <Navigate to="/" replace />;

    return (
        <div className="min-h-screen bg-brand-cream" data-testid="article-page">
            <Navbar />

            <article className="pt-32 pb-24 max-w-[820px] mx-auto px-6 lg:px-10">
                <Link
                    to="/#actualites"
                    className="inline-flex items-center gap-2 text-sm text-brand-primary mb-10 ll-link-underline"
                    data-testid="article-back-link"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Retour aux conseils santé
                </Link>

                <p className="ll-eyebrow text-brand-primary mb-5">
                    {article.tag} · {article.date}
                </p>
                <h1 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-brand-ink">
                    {article.title}
                </h1>

                <div className="mt-10 aspect-[16/9] overflow-hidden border border-brand-line">
                    <img src={article.cover} alt={article.title} className="w-full h-full object-cover" />
                </div>

                <div className="mt-10 space-y-5 font-sans text-lg leading-relaxed text-brand-ink/80">
                    {article.body.map((p, i) => (
                        <p key={i}>{p}</p>
                    ))}
                </div>

                <div className="mt-14 border-t border-brand-line pt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <p className="font-sans text-brand-ink/65">
                        Des questions ? Nos pharmaciens sont à votre écoute.
                    </p>
                    <Link to="/#contact" className="ll-btn ll-btn-primary">
                        Nous contacter
                    </Link>
                </div>
            </article>

            <Footer />
        </div>
    );
}
